import $ from 'jquery';

$(function() {
    $('a').not('.accessibility').on('click', function (event) {
        if (this.hash !== '') {
            event.preventDefault();

            // eslint-disable-next-line prefer-destructuring
            const hash = this.hash;

            $('html, body').animate({
                scrollTop: $(hash).offset().top,
            }, 800, function () {
                window.location.hash = hash;
            });
            if (hash === '#spontaneous-application') {
                $('#spontaneous-application').addClass('opened');
            }
        }
    });
    $('.close-application').on('click', function (e) {
        e.preventDefault();
        $('#spontaneous-application').removeClass('opened');
    });
});
